
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M88.54 44.27A44.27 44.27 0 1144.27 0a44.27 44.27 0 0144.27 44.27","fill":"#ee7203"}}),_c('path',{attrs:{"d":"M10.08 46.06c0-11.43 6.29-16.71 13.1-16.71s13.11 5.28 13.11 16.71S30 62.77 23.18 62.77s-13.1-5.28-13.1-16.71zm22.61 0c0-9.55-4.32-13.59-9.51-13.59s-9.5 4-9.5 13.59 4.37 13.59 9.5 13.59 9.51-4.04 9.51-13.59zM42.53 37.37a8.14 8.14 0 0116.27 0 8.14 8.14 0 01-16.27 0zm13.15 0a5 5 0 10-10 0 5 5 0 1010 0zm13.39-7.63h3.41L51.93 62.38h-3.4zm-6.86 25a8.11 8.11 0 118.11 8 8 8 0 01-8.11-7.99zm13.15 0a5.04 5.04 0 10-10.08 0 5.04 5.04 0 1010.08 0z","fill":"#fff"}})])
          )
        }
      }
    